import { useEffect } from 'react';
import Intercom from '@intercom/messenger-js-sdk';

import { isAuthenticatedUserSelector, userDataSelector } from 'store/selectors/userSelectors';
import { useTypedSelector } from 'hooks/useTypedSelector';
import { INTERCOM_APP_ID } from 'utils/constants/constants';

export default function() {
  const { createdDate, email, name, id } = useTypedSelector(userDataSelector);
  const isAuthenticatedUser = useTypedSelector(isAuthenticatedUserSelector);

  useEffect(() => {
    if (!isAuthenticatedUser || !INTERCOM_APP_ID || !id) {
      return;
    }

    try {
      Intercom({
        app_id: INTERCOM_APP_ID,
        // @ts-ignore Intercom accepts numeric IDs
        user_id: id,
        name,
        email,
        // @ts-ignore Intercom accepts date strings
        created_at: createdDate,
      });
    } catch (error) {
      console.error('Intercom initialization error:', error);
    }
  }, [id, isAuthenticatedUser]);
}
